"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _Modal = _interopRequireDefault(require("./Modal"));
var _confirm = _interopRequireDefault(require("./confirm"));
var _Sidebar = _interopRequireDefault(require("./Sidebar"));
_Modal["default"].info = function (props) {
  var config = (0, _objectSpread2["default"])({
    type: 'info',
    okCancel: false
  }, props);
  return (0, _confirm["default"])(config);
};
_Modal["default"].success = function (props) {
  var config = (0, _objectSpread2["default"])({
    type: 'success',
    iconType: 'check_circle',
    okCancel: false
  }, props);
  return (0, _confirm["default"])(config);
};
_Modal["default"].error = function (props) {
  var config = (0, _objectSpread2["default"])({
    type: 'error',
    iconType: 'error',
    okCancel: false
  }, props);
  return (0, _confirm["default"])(config);
};
_Modal["default"].warn = function (props) {
  var config = (0, _objectSpread2["default"])({
    type: 'warning',
    iconType: 'warning',
    okCancel: false
  }, props);
  return (0, _confirm["default"])(config);
};
_Modal["default"].warning = _Modal["default"].warn;
_Modal["default"].confirm = function (props) {
  var config = (0, _objectSpread2["default"])({
    type: 'confirm',
    okCancel: true
  }, props);
  return (0, _confirm["default"])(config);
};
_Modal["default"].Sidebar = _Sidebar["default"];
var _default = _Modal["default"];
exports["default"] = _default;